import { createAction } from '../common';

export const SET_STEP_STATE = 'setStepState';
export const setStepStateAction = createAction(SET_STEP_STATE);
